import { Theme, alpha } from '@mui/material';

export default {
    menu: {
        '.MuiPaper-root': {
            borderRadius: '4px',
            boxShadow: (theme: Theme) => `0px 4px 16px 0px ${alpha(theme.palette.text.primary, 0.16)}`,
        },
        '.MuiList-root': {
            py: 0.5,
            width: '130px',
        },
        '.MuiMenuItem-root': {
            px: 1.5,
            py: '7px',
        },
    },
    iconHolder: {
        height: '18px',
        display: 'inline-flex',
        width: '16px',
        alignItems: 'center',
        fontSize: '16px',
        mr: 1,
        flexShrink: 0,
    },

    header: {
        position: 'relative',
        zIndex: 10,
        padding: '5px 10px 4px',
        backgroundColor: (theme: Theme) => alpha(theme.palette.text.primary, 0.08),

        '.MuiTypography-root': {
            marginLeft: '5px',
        },
    },
    treeRow: {
        display: 'flex',
        position: 'relative',
        width: '100%',
        padding: '5px 10px 4px 20px',

        '&::before': {
            content: '" "',
            position: 'absolute',
            left: '18px',
            top: '6px',
            width: '8px',
            height: '8px',
            zIndex: 2,
            borderBottom: (theme: Theme) => `1px dotted ${alpha(theme.palette.text.primary, 0.75)}`,
        },

        '&::after': {
            content: '""',
            position: 'absolute',
            left: '8px',
            top: '-13px',
            width: '9px',
            zIndex: 2,
            height: '100%',
            borderRight: (theme: Theme) => `1px dotted ${alpha(theme.palette.text.primary, 0.75)}`,
        },

        '.MuiTypography-root': {
            marginLeft: '10px',
        },

        '&:hover': {
            cursor: 'move',
            backgroundColor: (theme: Theme) => alpha(theme.palette.text.primary, 0.06),
        },

        '&.selected': {
            backgroundColor: (theme: Theme) => alpha(theme.palette.text.primary, 0.08),
        },

        '&:last-of-type > .MuiBox-root::after': {
            content: 'none',
        },
    },
};
